const WhiteSpace = require("./tokenizer/pattern/whiteSpace");
const OpenParenthesis = require("./tokenizer/character/openParenthesis");
const CloseParenthesis = require("./tokenizer/character/closeParenthesis");
const NumberTokenizer = require("./tokenizer/pattern/numberTokenizer");
const Variable = require("./tokenizer/pattern/variable");
const StingTokenizer = require("./tokenizer/stringTokenizer");
const Keywords = require("./tokenizer/pattern/keywords");
const ObjectToken = require("./tokenizer/object");

class TokenParser {
    constructor(registry) {
        this.registry = registry;
        this.tokenizers = [
            WhiteSpace,
            OpenParenthesis,
            CloseParenthesis,
            Keywords,
            NumberTokenizer,
            Variable,
            StingTokenizer,
            ObjectToken
        ];

        this.tokenizers = this.tokenizers.map(className => new className(this.registry));
    }

    parse(text) {
        text = text.replace(/\n/g, ' ');
        const textLength = text.length;
        let currentPosition = 0;
        const tokens = [];

        while (currentPosition < textLength) {
            let tokenized = false;
            for (let tokenizer of this.tokenizers) {
                const [consumedChars, token] = tokenizer.getToken(text, currentPosition);
                if (token && token.value) {
                    tokens.push(token);
                }
                if (consumedChars !== 0) {
                    currentPosition += consumedChars;
                    tokenized = true;
                    break;
                }
            }

            if (!tokenized) {
                throw 'I dont know what this character is: ' + text[currentPosition];
            }
        }
        return tokens;
    }

    getTokenizer(type) {
        return this.tokenizers.find(tokenizer => tokenizer.type === type);
    }
}

module.exports = TokenParser;
